import { createApp } from 'vue'
import App from './pages/App.vue'
import './assets/styles/dealers.scss'
import { debugUtils, setupGlobalErrorTracking, enableVueDebugging } from './utils/debug.js'

// Enable debugging utilities
setupGlobalErrorTracking()
enableVueDebugging()

const app = createApp(App)

// Global error handler for unhandled errors
app.config.errorHandler = (err, instance, info) => {
  debugUtils.error('Vue Application Error', err, 'Vue')
  
  // Additional detailed logging with error protection
  console.group('🚨 Detailed Vue Error Information')
  try {
    console.error('Error message:', err?.message || 'Unknown error')
    console.error('Error stack:', err?.stack || 'No stack trace available')
    console.error('Error info:', info || 'No error info available')
    console.error('Component instance:', instance || 'No component instance')
    console.error('Component name:', instance?.$options?.name || instance?.$options?.__name || 'Anonymous')
    console.error('Component props:', instance?.$?.props || {})
    console.error('Component data:', instance?.$?.data || {})
    console.error('Timestamp:', new Date().toISOString())
  } catch (loggingError) {
    console.error('Error while logging Vue error:', loggingError)
  }
  console.groupEnd()
}

// Global warning handler for Vue warnings
app.config.warnHandler = (msg, instance, trace) => {
  debugUtils.warn('Vue Warning', { message: msg, trace }, 'Vue')
}

debugUtils.log('Vue application starting...', null, 'Main')
app.mount('#dealers-app')
debugUtils.log('Vue application mounted successfully', null, 'Main')